document.querySelectorAll('.ce_rsce_map, .ce_rsce_textMap').forEach((mapContainer, index) => {
  const mapWrapper = mapContainer.querySelector('.map');
  if (!mapWrapper) {
    return;
  }
  const dsgvoHint = mapWrapper.querySelector('.datenschutz-hinweis');

  if (dsgvoHint) {
    const mapButton = dsgvoHint.querySelector('.button');

    mapButton.addEventListener('click', function () {
      localStorage.setItem('mapData', 'true');
      dsgvoHint.remove();
      loadGoogleMaps(() => initMap(mapWrapper, index));
    });

    if (localStorage.getItem('mapData') === 'true') {
      dsgvoHint.remove();
      loadGoogleMaps(() => initMap(mapWrapper, index));
    }
  }
});

function initMap(mapWrapper, index) {
  if (mapWrapper.dataset.mapInitialized === 'true') {
    return;
  }

  let mapLat = parseFloat(mapWrapper.getAttribute('data-latitude'));
  let mapLong = parseFloat(mapWrapper.getAttribute('data-longitude'));
  let mapZoom = parseInt(mapWrapper.getAttribute('data-zoom'));
  let mapTitle = mapWrapper.getAttribute('data-title') || 'Hauptstandort';

  const mapElement = document.createElement('div');
  mapElement.classList.add('gmap');
  mapElement.style.width = '100%';
  mapElement.style.height = '100%';
  mapWrapper.appendChild(mapElement);

  const map = new google.maps.Map(mapElement, {
    center: { lat: mapLat, lng: mapLong },
    zoom: mapZoom,
    mapId: "2e93dd57298047978b729fbc",
  });

  new google.maps.Marker({
    position: { lat: mapLat, lng: mapLong },
    map: map,
    title: mapTitle,
  });

  mapWrapper.dataset.mapInitialized = 'true';
}

// Lädt Google Maps nur einmal
let googleMapsLoading = false;
function loadGoogleMaps(callback) {
  if (window.google && window.google.maps) {
    callback();
    return;
  }

  if (!googleMapsLoading) {
    googleMapsLoading = true;
    const script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyB8HFkwHdABCsqi-0MTYQSqMPvlhLnng4Y&callback=mapsLoaded";
    script.async = true;
    document.head.appendChild(script);
  }

  window.mapsLoaded = () => {
    document.querySelectorAll('.ce_rsce_map .map, .ce_rsce_textMap .map').forEach((mapWrapper, i) => {
      if (!mapWrapper.querySelector('.datenschutz-hinweis')) {
        initMap(mapWrapper, i);
      }
    });
  };
}
